import "./Footer.css";
import { useEffect, useState } from "react"; //
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  const [active, setActive] = useState("home");

  useEffect(() => {
    const sections = ["sobre", "especialidades", "contato", "enderecos"];

    const handleScroll = () => {
      let current = "home";

      sections.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          const top = element.offsetTop - 120; // ajuste fino aqui
          if (window.scrollY >= top) {
            current = id;
          }
        }
      });

      setActive(current);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer className="footer scroll-reveal-opacity">
      <div className="container">

        <div className="row footer-top">

          {/* SOBRE */}
          <div className="col-12 col-lg-5 footer-about scroll-reveal-opacity">
            <span className="footer-logo">
              Dr. Bruno Corrêa
            </span>

            <p className="footer-text">
              Referência em Urologia Reconstrutora, focado em devolver a
              funcionalidade e dignidade a casos complexos através de um
              atendimento de imersão e excelência cirúrgica.
            </p>

            <div className="footer-crm">
              <p>Registro Profissional</p>
              <strong>CRM 52-1133411</strong>
            </div>
          </div>

          {/* NAVEGAÇÃO */}
          <div className="col-12 col-lg-4 footer-links scroll-reveal-opacity">
            <div className="row">

              <div className="col-6">
                <span className="footer-title">Navegação</span>
                <nav>
                  <a href="/">Home</a>
                  <a
                    className={`nav-link ${active === "sobre" ? "active" : ""}`}
                    onClick={() => goToSection("sobre")}
                  >
                    Sobre
                  </a>
                  <a
                    className={`nav-link ${active === "especialidades" ? "active" : ""}`}
                    onClick={() => goToSection("especialidades")}
                  >
                    Especialidades
                  </a>
                  <a
                    className={`nav-link ${active === "contato" ? "active" : ""}`}
                    onClick={() => goToSection("contato")}
                  >
                    Contato
                  </a>
                  <a
                    className={`nav-link ${active === "enderecos" ? "active" : ""}`}
                    onClick={() => goToSection("enderecos")}
                  >
                    Endereços
                  </a>
                </nav>
              </div>

              <div className="col-6">
                <span className="footer-title">Outros</span>
                <nav>
                  <a href="#">Política de Privacidade</a>
                  <a href="#">Termos de Uso</a>
                </nav>
              </div>

            </div>
          </div>

          {/* SOCIAL */}
          <div className="col-12 col-lg-3 footer-social scroll-reveal-opacity">
            <span className="footer-title">Redes Sociais & Presença</span>

            <div className="social-grid">

              <a href="https://www.doctoralia.com.br/z/iX6S8M" className="social-item" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-user-doctor"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61578553245338" className="social-item" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-facebook-f"></i>
              </a>

              <a href="https://www.instagram.com/brunocorreaurologista" className="social-item" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>

              <a href="https://www.tiktok.com/@brunocorreaurologista" className="social-item" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-tiktok"></i>
              </a>

              <a href="https://www.youtube.com/@brunocorreaurologista" className="social-item" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-youtube"></i>
              </a>



            </div>

            <div className="footer-note">
              <p className="mini-title">Conteúdo Informativo</p>
              <p>
                As informações contidas neste site têm caráter
                informativo e educativo, não substituindo a
                consulta médica.
              </p>
            </div>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">

          <p>© {new Date().getFullYear()} Dr. Bruno Corrêa. Todos os direitos reservados.</p>

          <div className="footer-extra">

            <p>
              Desenvolvido por{" "}
              <a
                href="https://casoftwares.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-dev-link"
              >
                CA Softwares
              </a>
            </p>
          </div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;